import { createContext, useCallback, useContext, useState } from "react";

const QuickBuyContext = createContext(null);

export const QuickBuyProvider = ({ children }) => {
  const [product, setProduct] = useState(null);

  const openQuickBuy = useCallback((p) => setProduct(p), []);
  const closeQuickBuy = useCallback(() => setProduct(null), []);

  return (
    <QuickBuyContext.Provider value={{ product, openQuickBuy, closeQuickBuy }}>
      {children}
    </QuickBuyContext.Provider>
  );
};

export const useQuickBuy = () => useContext(QuickBuyContext);
